module.exports = __webpack_public_path__ + "static/media/plane.fe2ecab6.jpg";